import theme from 'theme'

const ITEM_HEIGHT = 42
const ITEM_PADDING_TOP = 7
const WIDTH = 240

export const getFormControlSx = (isOpen: boolean) => ({
  width: WIDTH,

  '.MuiTypography-root': {
    color: theme.colors.menuItemText,
    fontFamily: theme.typography.fontFamily.primary,
    fontSize: theme.typography.fontSize.large,
    fontStyle: 'normal',
    fontWeight: theme.typography.fontWeight.normal,
    lineHeight: '22px',
    marginBottom: `${theme.spacing.xSmall}px`
  },

  '.MuiOutlinedInput-root': {
    backgroundColor: 'transparent',
    border: isOpen ? `1px solid ${theme.colors.cta}` : `1px solid ${theme.colors.inputBorderSubtle}`,
    borderRadius: theme.attributes.borderRadius.secondary,
    color: theme.colors.cta,
    fontWeight: theme.typography.fontWeight.bold,

    '&:hover': {
      border: isOpen ? `1px solid ${theme.colors.cta}` : '1px solid rgba(255, 255, 255, 0.3)'
    },

    '&.Mui-focused': {
      border: isOpen ? `1px solid ${theme.colors.cta}` : '1px solid rgba(255, 255, 255, 0.4)'
    },

    '.MuiOutlinedInput-notchedOutline': {
      border: 'none'
    }
  },

  '.MuiSelect-select': {
    padding: `${theme.spacing.md}px 16px`,
    fontSize: theme.typography.fontSize.large
  },

  '.MuiSvgIcon-root': {
    color: theme.colors.selectChevron
  }
})

export const menuItemSx = {
  padding: `${theme.spacing.sm}px 16px`,
  color: theme.colors.menuItemText,
  fontFamily: theme.typography.fontFamily.primary,
  fontSize: theme.typography.fontSize.large,
  fontWeight: theme.typography.fontWeight.bold,
  lineHeight: '22px',

  '&:hover': {
    backgroundColor: theme.colors.calendarActionHover
  },

  '&.Mui-selected': {
    backgroundColor: 'transparent',

    '&:hover': {
      backgroundColor: theme.colors.calendarActionHover
    }
  },

  '.MuiListItemText-root': {
    '.MuiTypography-root': {
      color: theme.colors.menuItemText,
      fontFamily: theme.typography.fontFamily.primary,
      fontSize: theme.typography.fontSize.large,
      fontWeight: theme.typography.fontWeight.bold,
      lineHeight: '22px'
    }
  }
}

export const MenuProps = {
  PaperProps: {
    sx: {
      backgroundColor: theme.colors.menuBg,
      backgroundImage: 'none',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      borderRadius: theme.attributes.borderRadius.secondary,
      marginTop: `${theme.spacing.xSmall}px`,

      '.MuiList-root': {
        padding: `${theme.spacing.xsm}px 0`
      },

      '.MuiCheckbox-root svg rect': {
        stroke: theme.colors.checkboxUnchecked
      },

      '.MuiCheckbox-root.Mui-checked svg path': {
        stroke: theme.colors.checkboxChecked
      }
    },
    style: {
      maxHeight: ITEM_HEIGHT * 6 + ITEM_PADDING_TOP * 2,
      width: WIDTH
    }
  }
}

export const checkboxSx = {
  padding: 0,
  marginRight: `${theme.spacing.xSmall}px`,
  color: theme.colors.checkboxUnchecked,

  '&.Mui-checked': {
    color: theme.colors.menuItemText
  },

  '&.MuiCheckbox-indeterminate': {
    color: theme.colors.menuItemText
  }
}
